export default {
  name: 'InlineContainer',
  props: {
    title: {
      type: String,
      default: 'RelayOS IRC'
    },
    showSettings: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      settingsOpen: false
    };
  },
  methods: {
    toggleSettings: function toggleSettings() {
      this.settingsOpen = !this.settingsOpen;
      this.$emit('toggle-settings', this.settingsOpen);
    }
  }
};